module.exports = __webpack_public_path__ + "hotel.6c20071f2d41369db003.eot";


//////////////////
// WEBPACK FOOTER
// /Users/abassey/side-proj/emp21-new/src/fonts/hotel.eot
// module id = ../../../../../src/fonts/hotel.eot
// module chunks = styles